import { useEffect } from 'react';
import { base44 } from '@/api/base44Client';

// Emits `phone_click` for any click on a tel: link, and `get_directions` for any
// click on a Google Maps link (directions / "open in maps"). Mirrors the pattern
// used by BookingClickTracker: one delegated listener at document level, so every
// phone number and every "Άνοιξε στο Google Maps" link on every page is covered
// without touching each page's markup individually.
//
// Together with BookingClickTracker (`booking_link_click`), these are the
// "πιέσεις" (contact/booking intent clicks) signal for Google Analytics reporting.
const MAPS_SELECTOR = 'a[href*="maps.google."], a[href*="maps.app.goo.gl"], a[href*="google.com/maps"], a[href^="geo:"]';

export default function ContactClickTracker() {
  useEffect(() => {
    const onClick = (e) => {
      const telAnchor = e.target?.closest?.('a[href^="tel:" i], a[href^=" tel:" i]');
      if (telAnchor) {
        // Phone dialer backgrounds the page immediately — the SDK flushes its queue
        // via beacon on visibilitychange, so the event survives the app switch.
        base44.analytics.track({ eventName: 'phone_click', properties: { page_url: window.location.pathname } });
        if (typeof window.gtag === 'function') {
          window.gtag('event', 'phone_click', {
            link_url: telAnchor.href,
            page_path: window.location.pathname,
          });
        }
        return;
      }

      const mapsAnchor = e.target?.closest?.(MAPS_SELECTOR);
      if (mapsAnchor) {
        base44.analytics.track({ eventName: 'get_directions' });
        if (typeof window.gtag === 'function') {
          window.gtag('event', 'get_directions', {
            link_url: mapsAnchor.href,
            page_path: window.location.pathname,
          });
        }
      }
    };
    document.addEventListener('click', onClick, true);
    return () => document.removeEventListener('click', onClick, true);
  }, []);

  return null;
}